export default __webpack_public_path__ + "static/media/otp3.45f25160.jpeg";